import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useFavourites } from "@/contexts/FavouritesContext";

// variant "overlay" sits on a card image; "pill" sits in a recipe page's action row.
export default function HeartButton({ kind = "recipe", id, count = 0, variant = "overlay", className = "" }) {
  const { user } = useAuth();
  const fav = useFavourites();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!id || !fav) return null;
  const on = fav.isSaved(kind, id);
  const n = fav.countFor(kind, id) ?? count ?? 0;

  const click = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast("Sign in to save Favourites");
      nav(`/login?next=${encodeURIComponent(window.location.pathname)}`);
      return;
    }
    setBusy(true);
    await fav.toggle(kind, id);
    setBusy(false);
  };

  const base = variant === "pill"
    ? `btn-outline-ink !py-2.5 !px-4 text-sm ${on ? "!bg-rose-50 !border-rose-300 !text-rose-700" : "!bg-white !text-rf-ink"}`
    : "inline-flex items-center gap-1 rounded-full bg-white/95 shadow-md px-2.5 py-1.5 text-xs font-bold text-rf-ink hover:scale-105 transition-transform";

  return (
    <button type="button" onClick={click} disabled={busy} aria-pressed={on}
            aria-label={on ? "Remove from Favourites" : "Save to Favourites"}
            title={on ? "Remove from Favourites" : "Save to Favourites"}
            data-testid={`fav-btn-${kind}-${id}`} className={`${base} ${className}`}>
      <Heart size={variant === "pill" ? 16 : 16} weight={on ? "fill" : "bold"} className={on ? "text-rose-600" : ""} />
      {variant === "pill" && <span>{on ? "Saved" : "Favourite"}</span>}
      {n > 0 && <span data-testid={`fav-count-${kind}-${id}`}>{n}</span>}
    </button>
  );
}
